<template>
  <article id="admin-wrapper" class="contents-wrapper">
    <router-view />
  </article>
</template>

<script lang="ts">
export default {
  setup() {
    return {};
  },
  created() {
    console.log("[AdminWrapper] created");
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped></style>
